<template>
  <div class="warpper">
    <tip
      v-if="ifShow && sendMessage.length > 0"
      v-bind:status="sendStatus"
      v-bind:message="sendMessage"
    ></tip>
    <Loading :stop="loadingShow"></Loading>
  </div>
</template>
<script>
import Tip from "@/components/common/tip";
import Loading from "@/components/common/loading";
import { mapState, mapActions } from "vuex";
import { Login } from "../../util/api.js";

export default {
  name: "Implicit",
  components: { Tip, Loading },
  data() {
    return {
      sendStatus: false,
      sendMessage: "",
      loadingShow: true,
      okatCode: this.$route.query.code
    };
  },
  computed: mapState({
    ifShow: state => state.ifShowMessage
  }),
  methods: {
    setCookie(name, value, day) {
      if (day !== 0) {
        //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
        var expires = day * 24 * 60 * 60 * 1000;
        var date = new Date(+new Date() + expires);
        document.cookie = name + "=" + value + ";expires=" + date.toUTCString();
      } else {
        document.cookie = name + "=" + value;
      }
    },
    sendLogin: function(sendData) {
      console.log(this.ifShow);
      let that = this;
      that.loadingShow = true;
      let res = Login(sendData)
        .then(function(res) {
          const result = JSON.parse(decodeURIComponent(res.data));
          if (result.status == 200) {
            that.setCookie("rstuserId", result.data.UserId, 1);
            that.setCookie("rstuserName", result.data.Username, 1);
            if (
              result.data.Authorities &&
              result.data.Authorities.length != 0
            ) {
              that.setCookie(
                "authority",
                result.data.Authorities[0].authority,
                1
              );
            }
            that.$router.push("settingDays");
          } else {
            that.$store.commit("getIfShowMessage", true);
            that.sendStatus = false;
            that.sendMessage = (result.message ? result.message : "登录失败") + " \n 3秒后返回登录页";
            setTimeout(_ => {
              that.$router.push("login");
            }, 4000);
            
          }
          that.loadingShow = false;
        })
        .catch(function(error) {
          that.loadingShow = false;
          console.log(error);
        });
    }
  },
  mounted: function() {
    let that = this;
    that.$store.commit("getIfShowMessage", false);

    if (!that.okatCode || "" == that.okatCode && "null" == that.okatCode) {
        that.$router.push("login");
        return;
    }
    const sendData = {
      code: that.okatCode
    };
    that.sendLogin(sendData);
  }
};
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/Implicit.vue